// Status constants
export const STATUS = {
  ACTIVE: 'active',           // Salesforce accounts with last ship date <= 52 Weeks
  ACTIVE_OLDER: 'activeOlder', // Salesforce accounts with last ship date > 52 Weeks
  PROSPECT: 'prospect',       // Salesforce prospects     
  TARGET: 'target',       // Salesforce prospects     
};